import { Checkbox, FormControlLabel, Typography } from '@mui/material'
import type { TemplateNodeSchema } from '@ulysses-inc/harami_api_client'
import { useState } from 'react'
import { useSelectedTraceKeyName } from 'src/features/traceKeys/hooks/useSelectedTraceKeyName'
import { useChangeTraceKey } from 'src/state/ducks/templates/selectors'
import { OptionWrapper } from '../questionOptions/dumb'
import { EditTraceKeyModal } from './EditTraceKeyModal'

type Props = {
  node: TemplateNodeSchema
  optionWrapperStyle?: React.CSSProperties
}

export const EditTraceKeyCheckbox = ({ node, optionWrapperStyle }: Props) => {
  const [isOpenModal, setIsOpenModal] = useState(false)

  const selectedTraceKeyItemName = useSelectedTraceKeyName(
    node.traceKey?.traceKeyId,
  )

  const { changeTraceKey } = useChangeTraceKey()

  const handleClick = () => {
    if (!selectedTraceKeyItemName) {
      setIsOpenModal(true)
    } else {
      changeTraceKey(node, undefined)
    }
  }

  return (
    <>
      <OptionWrapper style={optionWrapperStyle}>
        <FormControlLabel
          control={
            <Checkbox
              checked={!!selectedTraceKeyItemName}
              onChange={handleClick}
            />
          }
          label={
            <Typography
              variant="body2"
              sx={{ display: 'flex', maxWidth: 256, whiteSpace: 'nowrap' }}
            >
              検索キーに紐付ける
              {selectedTraceKeyItemName && (
                <>
                  {'('}
                  <Typography
                    variant="body2"
                    component="span"
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {selectedTraceKeyItemName}
                  </Typography>
                  {')'}
                </>
              )}
            </Typography>
          }
        />
      </OptionWrapper>
      {isOpenModal && (
        <EditTraceKeyModal
          onClose={() => setIsOpenModal(false)}
          questionNode={node}
        />
      )}
    </>
  )
}
